import React from "react";
import { formatBalance } from "../../../../Helpers/Pricing";

import { Row, Skeleton, Tooltip } from "antd";
import GlobalTooltipIcon from "../../Common/GlobalTooltipIcon";
import "./index.scss";
import NotFoundCard from "../../Common/NotFoundCard";
import ErrorCard from "../../Common/ErrorCard";

const TotalProfitAndLoss = (props) => {
  const {
    data,
    data2,
    startDate,
    endDate,
    loading,
    error,
    errorMsg,
    errorCode,
  } = props;

  function amountHandler(amount, color) {
    if (amount < 0) {
      return (
        <div className="delivered-order-head debit">
          ₹ {formatBalance(amount).replace("-", "")}
        </div>
      );
    }
    if (!!amount) {
      if (color === "debit") {
        return (
          <div className="delivered-order-head debit">
            ₹ {formatBalance(amount)}
          </div>
        );
      } else {
        return (
          <div className="delivered-order-head credit">
            ₹ {formatBalance(amount)}
          </div>
        );
      }
    } else {
      return <div className="delivered-order-head ">0</div>;
    }
  }

  const bottomRightFields = [
    { key: "total_expenses", label: "Total Expenses" },
    { key: "total_income", label: "Total Income" },
    { key: "total_net_profit", label: "Net Profit" },
  ];

  if (loading) {
    return (
      <Row style={{ marginBottom: "30px" }}>
        <Skeleton active />
      </Row>
    );
  }

  if (!loading && error) {
    return (
      <div id="fade-in" className="deductedFromWallet">
        <div className="topPerformingProductHead">
          {" "}
          <span className="name">Net Profit & Loss</span> |{" "}
          <span>
            {startDate} - {endDate}
          </span>
        </div>

        <ErrorCard errorMsg={errorMsg} errorCode={errorCode} />
      </div>
    );
  }

  if (Object.entries(data).length === 0) {
    return (
      <div id="fade-in" className="deductedFromWallet">
        <div className="topPerformingProductHead">
          {" "}
          <span className="name">Net Profit & Loss</span> |{" "}
          <span>
            {startDate} - {endDate}
          </span>
        </div>

        <NotFoundCard
          mainHeading={"Oops! No Data Found."}
          secondHeading={
            <p>
              Looks like there are no data in <span>current Date Range</span>.
            </p>
          }
          thirdHeading={
            <p>
              Please <span>select another Date Range</span> from Date Picker to
              filter data.
            </p>
          }
        />
      </div>
    );
  }
  return (
    <div id="fade-in" className="deductedFromWallet">
      <div className="topPerformingProductHead">
        {" "}
        <span className="name">Net Profit & Loss</span> |{" "}
        <span>
          {startDate} - {endDate}
        </span>
      </div>
      <div className="product-heads">
        <div className="name-head">Source</div>

        <div className="delivered-order-head">Processed</div>
      </div>

      <div className="product-row-wraper">
        {bottomRightFields.map((field, index) => {
          if (field.key === "total_net_profit") {
            return (
              <div
                key={field.key}
                className={`product-row  ${
                  index === bottomRightFields.length - 1 ? "last-row" : ""
                }`}
              >
                <div className="name-head">{field.label}</div>

                {data[field.key] < 0
                  ? amountHandler(data[field.key], "debit")
                  : amountHandler(data[field.key])}
              </div>
            );
          }

          if (data[field.key] != 0 && field !== "total_net_profit") {
            return (
              <div
                key={field.key}
                className={`product-row ${
                  index === bottomRightFields.length - 1 ? "last-row" : ""
                }`}
              >
                <div className="name-head">{field.label}</div>

                {amountHandler(data[field.key])}
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default TotalProfitAndLoss;
